import React from 'react';
import styled from 'styled-components';
import theme from '../utils/theme';
import MainBanner from './common/MainBanner';
import PhoneMockupImg from '../assets/LoanComparisonBanner/phone-loan-info.png';

export default function LoanComparisonBanner() {
  return (
    <MainBanner>
      <BannerDiv>
        <BannerText>
          <BiggerText>
            한번의 조회로<br />
            다양한 자동차대출을<br />
            확인하실 수 있어요!
          </BiggerText>
          <BigText>
            원하는 한도와 이자로<br />
            신속한 대출 신청을<br />
            할 수 있어요!<br />
          </BigText>
        </BannerText>
        <PhoneMockup src={PhoneMockupImg} alt="빨간색 자동차" />
      </BannerDiv>
    </MainBanner>
  );
}

const BiggerText = styled.span`
  color: ${theme.navyColor};
  font-weight: 800;
  font-size: 36px;
  line-height: 1.15;
  margin-bottom: 12px;
  text-align: right;
`;

const BigText = styled.span`
  color: ${theme.navyColor};
  font-size: 22px;
  line-height: 1.15;
  margin-top: 30px;
  font-weight: 400;
  text-align: right;
`;

const BannerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 0;
  h1 {
    color: ${theme.navyColor};
    font-weight: 700;
    font-size: 28px;
    line-height: 1.15;
    margin-bottom: 12px;
  }
  h5 {
    color: ${theme.gray60Color};
    font-weight: 400;
    font-size: 13px;
    margin-bottom: 16px;
  }
`;

const PhoneMockup = styled.img`
  // margin-top: 30px;
  width: 100%;
  height: auto;
  display: flex;
  align-self: center;
  object-fit: contain;
`;